module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/kbc-42c45c752fab0ed7ef83bb60d97f4331.svg";